// extracted by mini-css-extract-plugin
export var infoItem = "_sh-2";
export var title = "_sh-0";
export var value = "_sh-1";